import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Box, Typography, Snackbar, Alert } from '@mui/material';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Stage, Layer, Circle, Text, Group, Rect } from 'react-konva';
import LayoutKasir from './layoutKasir';
import { Logout, reset } from '../../fitur/AuthSlice';
import { apiHost } from '../../utils/apiHost';

const getApiBaseUrl = () => {
  const protocol = window.location.protocol === 'https:' ? 'https' : 'http';
  const baseUrl = (apiHost() || '').replace(/^https?:\/\//, '');
  return `${protocol}://${baseUrl}`;
};

const LayoutMeja = () => {
     const navigate = useNavigate();
      const dispatch = useDispatch();
  const user = useSelector(state => state.auth.user);
  const apiBaseUrl = getApiBaseUrl();
  const containerRef = useRef(null);
  const [size, setSize] = useState({ width: 900, height: 600 });
  const [tables, setTables] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snack, setSnack] = useState({ open: false, message: '', severity: 'success' });
  const [currentView, setCurrentView] = useState('layoutMeja');
  const [showPrinterSettings, setShowPrinterSettings] = useState(false);
  const [printerConnected, setPrinterConnected] = useState(false);
  const [printerInstance, setPrinterInstance] = useState(null);

  const fetchTables = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${apiBaseUrl}/getmeja`, { withCredentials: true });
      const mapped = (res.data.data || []).map((t, idx) => ({
        id: t.id,
        name: t.name || t.nama || `Meja ${t.id || idx + 1}`,
        x: Number(t.koordinatX) || 50 + ((t.id || idx) % 5) * 120,
        y: Number(t.koordinatY) || 50 + Math.floor((t.id || idx) / 5) * 120,
        raw: t,
      }));
      setTables(mapped);
    } catch (err) {
      setSnack({ open: true, message: 'Gagal memuat meja', severity: 'error' });
    } finally {
      setLoading(false);
    }
  }, [apiBaseUrl]);

  useEffect(() => {
    fetchTables();

    const resize = () => {
      const el = containerRef.current;
      if (!el) return;
      const w = el.clientWidth || 900;
      const h = Math.max(400, Math.round((w * 2) / 3));
      setSize({ width: w - 4, height: h });
    };

    resize();
    window.addEventListener('resize', resize);
    return () => window.removeEventListener('resize', resize);
  }, [fetchTables]);

  const handleNavigate = (path) => {
    navigate(path);
  };

  const handleLogout = () => {
    try {
      dispatch(reset());
      dispatch(Logout());
      navigate('/');
    } catch (error) {
      console.error('Logout error:', error);
      navigate('/');
    }
  };

  const handleDragEnd = (e, id) => {
    const pos = e.target.position();
    setTables(prev => prev.map(t => (t.id === id ? { ...t, x: pos.x, y: pos.y } : t)));
  };

  return (
    <LayoutKasir
      currentView={currentView}
      onViewChange={setCurrentView}
      onNavigate={handleNavigate}
      onLogout={handleLogout}
      showPrinterSettings={showPrinterSettings}
      onShowPrinterSettings={setShowPrinterSettings}
      printerConnected={printerConnected}
      printerInstance={printerInstance}
      onSetPrinterInstance={setPrinterInstance}
    >
      <Box sx={{ p: 2, width: '100%', height: '100%', overflowY: 'auto' }} ref={containerRef}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
          <Typography variant="h6">Layout Meja</Typography>
        </Box>

        <Box sx={{ border: '1px dashed #ccc', borderRadius: 1, overflow: 'hidden' }}>
          <Stage width={size.width} height={size.height}>
            <Layer>
              <Rect x={0} y={0} width={size.width} height={size.height} fill="#f8f8f8" />
              {loading ? (
                <Group>
                  <Text text="Memuat..." x={20} y={20} fontSize={18} />
                </Group>
              ) : (
                tables.map(t => (
                  <Group key={t.id} x={t.x} y={t.y} draggable onDragEnd={(e) => handleDragEnd(e, t.id)}>
                    <Circle radius={36} fill="#1976d2" shadowBlur={6} />
                    <Text text={t.name} fontSize={14} fill="#fff" x={-28} y={-8} width={56} align="center" />
                  </Group>
                ))
              )}
            </Layer>
          </Stage>
        </Box>

        <Snackbar open={snack.open} autoHideDuration={4000} onClose={() => setSnack({ ...snack, open: false })}>
          <Alert severity={snack.severity} onClose={() => setSnack({ ...snack, open: false })}>
            {snack.message}
          </Alert>
        </Snackbar>
      </Box>
    </LayoutKasir>
  );
};

export default LayoutMeja;
   